import React from 'react';
import styles from './AchievementsList.module.scss';
import Achievement from './Achievement';
import { Api } from '../../../../lib/types/apiSpec';

type AchievementsListProps = {
  achievements: Api.AchievementBase[];
};

const AchievementsList = ({ achievements }: AchievementsListProps) => {
  if (!achievements?.length) {
    return null;
  }

  return (
    <ul className={styles.list}>
      {achievements.map(item => (
        <Achievement key={item.id} {...item} />
      ))}
    </ul>
  );
};

export default AchievementsList;
